import React, { useState, useEffect } from "react";
import "./Bonafide.css";
import Bonadoc from "./Bonadoc";
import AlertMessage from "../../AlertMessage";
import { Link } from "react-router-dom";

const Bonafide = () => {
  const [formData, setFormData] = useState({
    stdName: '',
    stdMother: '',
    religion: '',
    class: '',
    educationalYear: '',
    dob: '',
    birthPlace: '',
    registerno: '',
    reason: '',
    selectedBookNo: '',
    schoolName: "",
    udiseNumber: "",
    password: "",
    mobileNumber: "",
    language: "",
    telephoneNumber: "",
    address: "",
    taluka: "",
    jilha: "",
    email: "",
    generalRegisterNumber: "",
    boardName: "",
    indexNumber: "",
    schoolCode: "",
    sanlagnataKramank: "",
    manyataKramank: "",
    schoolLogo: "",
    caste: "",
    stdPhoto: "",
    aparId: "",
    studentId: "",
    panId: "",
    owtId: '',
    showOwtId: false,
    date: new Date().toISOString().split('T')[0],
  });

  const language = localStorage.getItem("language") || "English"
  const udiseNumber = localStorage.getItem("udiseNumber");
  const userStatus = localStorage.getItem("userStatus");
  const isEditable = userStatus === "DKglzhgYFYTDT141414HGCkkgfs22117785YFUTFybnujghhgtghghYFYVNOmC234567Omgkysfgvghyfjhyfvv56764" || localStorage.getItem("editable") === "true";
  const [isStudentActive, setIsStudentActive] = useState(true);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);


  useEffect(() => {
    setFormData({
      stdName: '',
      stdMother: '',
      religion: '',
      class: '',
      educationalYear: '',
      dob: '',
      birthPlace: '',
      registerno: '',
      reason: language === "English" ? "To avail of travel benefits" : "प्रवासाचे फायदे मिळावेत",
      selectedBookNo: '',
      division: '',
      caste: '',
      gender: '',
      owtId: '',
      showOwtId: false,
      date: new Date().toISOString().split('T')[0],
    });
  }, [language]);

  useEffect(() => {
    const fetchOutwardIds = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/outwardIds.json`);
        if (!response.ok) {
          throw new Error('Failed to fetch outward IDs');
        }
        const data = await response.json();

        if (data) {
          setFormData(prevData => ({
            ...prevData,
            owtId: data.current + 1
          }));
        }

      } catch (error) {
        console.error('Error fetching outward IDs:', error);
      }
    };
    if (udiseNumber) {
      fetchOutwardIds();
    }
  }, [udiseNumber, language]);


  const [duplicateStudents, setDuplicateStudents] = useState([]);
  const [showDuplicatePopup, setShowDuplicatePopup] = useState(false);

  const handleSelectStudent = (selectedStudent) => {
    setFormData((prevData) => ({
      ...prevData,
      stdName: selectedStudent.stdName || '',
      stdMother: selectedStudent.stdMother || '',
      religion: selectedStudent.religion || '',
      class: selectedStudent.currentClass || '',
      educationalYear: selectedStudent.educationalYear || '',
      dob: selectedStudent.dob || '',
      birthPlace: selectedStudent.birthPlace || '',
      dobInWords: selectedStudent.dobInWords || '',
      studentId: selectedStudent.studentId || '',
      stdSurname: selectedStudent.stdSurname || '',
      stdFather: selectedStudent.stdFather || '',
      stdAdharNo: selectedStudent.stdAdharNo || '',
      division: selectedStudent.division || '',
      caste: selectedStudent.caste || '',
      gender: selectedStudent.gender || '',
      stdPhoto: selectedStudent.stdPhoto || '',
      aparId: selectedStudent.aparId || '',
      studentId: selectedStudent.studentId || '',
      panId: selectedStudent.panId || '',


    }));
    console.log("selectedStudent", selectedStudent);

    setIsStudentActive(selectedStudent.isActive !== false); // Set to false if isActive is false
    updateFormWithStudentData(selectedStudent);
    setShowDuplicatePopup(false);
  };
  const [searchInput, setSearchInput] = useState('');

  const updateFormWithStudentData = (studentData) => {

    setFormData((prevData) => ({
      ...prevData,
      stdName: studentData.stdName || '',
      stdMother: studentData.stdMother || '',
      religion: studentData.religion || '',
      class: studentData.currentClass || '',
      educationalYear: studentData.educationalYear || '',
      dob: studentData.dob || '',
      birthPlace: studentData.birthPlace || '',
      dobInWords: studentData.dobInWords || '',
      studentId: studentData.studentId || '',
      stdSurname: studentData.stdSurname || '',
      stdFather: studentData.stdFather || '',
      stdAdharNo: studentData.stdAdharNo || '',
      caste: studentData.caste || '',
      stdPhoto: studentData.stdPhoto || '',
      prevSchool: studentData.prevSchool || '',
      dateOfAdmission: studentData.dateOfAdmission || '',
      nationality: studentData.nationality || '',
      serialNo: studentData.serialNo || '',
      bookno: studentData.bookno || '',
      registerno: studentData.registerNo || '',
      division: studentData.division || '',
      gender: studentData.gender || '',
      progress: language === "English" ? "Excellent" : "उत्कृष्ट",
      conduct: language === "English" ? "Excellent" : "उत्कृष्ट",
      reason: language === "English" ? "To avail of travel benefits." : "प्रवासाचे फायदे मिळावेत.",
      remark: language === "English" ? "Going Elsewhere." : "इतरत्र जात आहे.",
      aparId: studentData.aparId || '',
      studentId: studentData.studentId || '',
      panId: studentData.panId || '',
    }));

    setSearchInput(`${studentData.stdName || ''} ${studentData.stdFather || ''} ${studentData.stdSurname || ''}`.trim());
  };

  const clearFormData = () => {
    setFormData((prevData) => ({
      ...prevData,
      stdName: '',
      stdMother: '',
      religion: '',
      class: '',
      educationalYear: '',
      dob: '',
      birthPlace: '',
      dobInWords: '',
      studentId: '',
      stdSurname: '',
      stdFather: '',
      stdAdharNo: '',
      caste: '',
      prevSchool: '',
      dateOfAdmission: '',
      nationality: '',
      serialNo: '',
      bookno: '',
      registerno: '',
      division: '',
      gender: '',
      stdPhoto: '',
      aparId: '',
      studentId: '',
      panId: '',
      owtId: '',
      date: new Date().toISOString().split('T')[0],
    }));
    setSearchInput('');
  };


  const handleChange = async (event) => {
    const { name, value } = event.target;

    // Update the form data for the input being changed
    if (name === 'stdName') {
      setSearchInput(value);
      setFormData((prevData) => ({
        ...prevData,
        stdName: value,
        stdFather: '',
        stdSurname: ''
      }));
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }

    // Handle specific cases for stdName and registerno
    if (name === 'stdName') {

      if (!value.trim()) {
        clearFormData();
        return;
      }

      if (formData.registerno) {
        return;
      }

      try {
        const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version

        request.onsuccess = async (event) => {
          const db = event.target.result;
          const transaction = db.transaction(['studentData'], 'readonly');
          const objectStore = transaction.objectStore('studentData');
          const studentRequest = objectStore.getAll(); // Fetch all student records

          studentRequest.onsuccess = async (event) => {
            const data = event.target.result;


            if (data && typeof data === 'object') {
              const matchingStudents = [];

              Object.values(data).forEach((studentData) => {
                if (studentData) {
                  const fullName = `${studentData.stdName || ''} ${studentData.stdFather || ''} ${studentData.stdSurname || ''}`.toLowerCase();
                  if (fullName.includes(value.toLowerCase())) {
                    matchingStudents.push(studentData);
                  }
                }
              });

              if (matchingStudents.length > 1) {
                setDuplicateStudents(matchingStudents);
                setShowDuplicatePopup(true);
              } else if (matchingStudents.length === 1) {
                updateFormWithStudentData(matchingStudents[0]);
                setIsStudentActive(matchingStudents[0].isActive !== false);
              }
            }

          };

          studentRequest.onerror = (event) => {
            console.error("Error fetching student data from IndexedDB:", event.target.error);
          };
        };




        request.onerror = (event) => {
          console.error("Error opening IndexedDB:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    } else if (name === 'registerno') {
      // Only clear form data if the input is empty
      if (!value.trim()) {
        clearFormData();
        return;
      }

      // Fetch matching students from IndexedDB
      try {
        const request = indexedDB.open('SchoolManagementDB', 1);
        request.onsuccess = async (event) => {
          const db = event.target.result;
          const transaction = db.transaction(['studentData'], 'readonly');
          const objectStore = transaction.objectStore('studentData');
          const studentRequest = objectStore.getAll();

          studentRequest.onsuccess = async (event) => {
            const data = event.target.result;
            if (data && typeof data === 'object') {
              const matchingStudents = [];
              Object.values(data).forEach((serialData) => {
                if (serialData && serialData.registerNo === value) {
                  matchingStudents.push(serialData);
                }
              });

              if (matchingStudents.length >= 1) {
                const selectedStudent = matchingStudents.find(s => s.isActive !== false) || matchingStudents[0];
                updateFormWithStudentData(selectedStudent);
                setIsStudentActive(selectedStudent.isActive !== false);
              } else {
                console.log('No matching student found for register number:', value);
              }
            }
          };

          studentRequest.onerror = (event) => {
            console.error("Error fetching student data from IndexedDB:", event.target.error);
          };
        };

        request.onerror = (event) => {
          console.error("Error opening IndexedDB:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };


  const DuplicateStudentPopup = ({ duplicateStudents, onSelectStudent }) => {
    return (
      <div className="popup">
        <h4>{language === "English" ? "Select Student" : "विद्यार्थी निवडा"}</h4>
        <table className="student-table">
          <thead>
            <tr>
              <th>{language === "English" ? "Full Name" : "पूर्ण नाव"}</th>
              <th>{language === "English" ? "Class" : "वर्ग"}</th>
              <th>{language === "English" ? "Register No" : "नोंदणी क्र."}</th>
            </tr>
          </thead>
          <tbody>
            {duplicateStudents.map((student, index) => (
              <tr key={index} onClick={() => onSelectStudent(student)}>
                <td>{`${student.stdName || ''} ${student.stdFather || ''} ${student.stdSurname || ''}`}</td>
                <td>{student.currentClass}</td>
                <td>{student.registerNo}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const [isReasonOther, setIsReasonOther] = useState(false);

  const handleSelectChange = (event) => {
    const { value } = event.target;
    if (value === (language === "English" ? "Other" : "इतर")) {
      setIsReasonOther(true);
    } else {
      setIsReasonOther(false);
    }
    setFormData({ ...formData, reason: value });
  };

  // for fetch selected student 

  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1);
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          const objectStore = db.createObjectStore('studentData', { keyPath: 'studentId' });
          objectStore.createIndex('serialNo', 'serialNo', { unique: false });
        }
      };
      request.onerror = (event) => {
        console.error("Error opening IndexedDB:", event.target.error);
        reject(event.target.error);
      };
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
    });
  };


  const fetchStudentBySerialNo = async (serialNo) => {
    try {
      console.log("Fetching student for serialNo:", serialNo);
      const db = await openIndexedDB();
      const transaction = db.transaction(['studentData'], 'readonly');
      const objectStore = transaction.objectStore('studentData');
      const getAllRequest = objectStore.getAll();

      return new Promise((resolve, reject) => {
        getAllRequest.onsuccess = (event) => {
          const students = event.target.result;
          console.log("All students in studentData store:", students);
          const student = students.find((s) => String(s.serialNo) === String(serialNo));
          console.log("Found student for serialNo", serialNo, ":", student);
          resolve(student || null);
        };
        getAllRequest.onerror = (event) => {
          console.error("Error fetching student data:", event.target.error);
          reject(event.target.error);
        };
      });
    } catch (error) {
      console.error("Error in fetchStudentBySerialNo:", error);
      return null;
    }
  };
  useEffect(() => {
    const savedSerialNo = localStorage.getItem("selectedStudentSelectedNo") || localStorage.getItem("selectedStudentSerialNo") || '';
    if (savedSerialNo) {
      fetchStudentBySerialNo(savedSerialNo).then((studentData) => {
        console.log("Fetched student data for serialNo", savedSerialNo, ":", studentData);
        if (studentData) {
          setFormData(prev => ({
            ...prev,
            stdName: studentData.stdName || '',
            stdMother: studentData.stdMother || '',
            stdFather: studentData.stdFather || '',
            stdSurname: studentData.stdSurname || '',
            dobInWords: studentData.dobInWords || '',
            stdAdharNo: studentData.stdAdharNo || '',
            religion: studentData.religion || '',
            class: studentData.currentClass || '',
            educationalYear: studentData.educationalYear || '',
            dob: studentData.dob || '',
            birthPlace: studentData.birthPlace || '',
            registerno: studentData.registerNo || '',
            serialNo: studentData.serialNo || savedSerialNo,
            reason: language === "English" ? "To avail of travel benefits" : "प्रवासाचे फायदे मिळावेत",
            caste: studentData.caste || '',
            division: studentData.division || '',
            gender: studentData.gender || '',
            selectedBookNo: '',
            schoolName: "",
            udiseNumber: "",
            password: "",
            mobileNumber: "",
            language: "",
            telephoneNumber: "",
            address: "",
            taluka: "",
            jilha: "",
            email: "",
            generalRegisterNumber: "",
            boardName: "",
            indexNumber: "",
            schoolCode: "",
            sanlagnataKramank: "",
            manyataKramank: "",
            schoolLogo: "",
            stdPhoto: "",
            aparId: "",
            studentId: "",
            panId: "",
          }));
          setSearchInput(`${studentData.stdName || ''} ${studentData.stdFather || ''} ${studentData.stdSurname || ''}`.trim());
          setIsStudentActive(studentData.isActive !== false);
        } else {
          setAlertMessage(language === "English" ? "No student found ." : " विद्यार्थी सापडला नाही.");
          setFormData(prev => ({
            ...prev,
            stdName: '',
            stdMother: '',
            religion: '',
            stdAdharNo: '',
            class: '',
            educationalYear: '',
            dob: '',
            birthPlace: '',
            registerno: '',
            reason: language === "English" ? "To avail of travel benefits" : "प्रवासाचे फायदे मिळावेत",
            selectedBookNo: '',
            division: '',
            caste: '',
            gender: '',
            serialNo: savedSerialNo,
            schoolName: "",
            udiseNumber: "",
            password: "",
            mobileNumber: "",
            language: "",
            telephoneNumber: "",
            address: "",
            taluka: "",
            jilha: "",
            email: "",
            generalRegisterNumber: "",
            boardName: "",
            indexNumber: "",
            schoolCode: "",
            sanlagnataKramank: "",
            manyataKramank: "",
            schoolLogo: "",
            stdPhoto: "",
            aparId: "",
            studentId: "",
            panId: "",
          }));
          setSearchInput('');
        }
      });
    } else {
      setFormData(prev => ({
        ...prev,
        stdName: '',
        stdMother: '',
        religion: '',
        stdAdharNo: '',
        class: '',
        educationalYear: '',
        dob: '',
        birthPlace: '',
        registerno: '',
        reason: language === "English" ? "To avail of travel benefits" : "प्रवासाचे फायदे मिळावेत",
        selectedBookNo: '',
        division: '',
        caste: '',
        gender: '',
        serialNo: '',
        schoolName: "",
        udiseNumber: "",
        password: "",
        mobileNumber: "",
        language: "",
        telephoneNumber: "",
        address: "",
        taluka: "",
        jilha: "",
        email: "",
        generalRegisterNumber: "",
        boardName: "",
        indexNumber: "",
        schoolCode: "",
        sanlagnataKramank: "",
        manyataKramank: "",
        schoolLogo: "",
        stdPhoto: "",
        aparId: "",
        studentId: "",
        panId: "",
      }));
      setSearchInput('');
    }
  }, [language]);


  return (
    <div>
      {/* <Sidebar /> */}
      <AlertMessage message={alertMessage} show={showAlert} />
      <div
        className="main-content-of-page  Bonafide-Css"
        style={{ width: "90%" }}
      >
        <div className="bonafidecontent" style={{ width: "87%" }} >
          <h3 className='text-center mb-4' style={{ color: '#03365e', fontWeight: '600' }}>
            {language === "English"
              ? "Bonafide Certificate"
              : "बोनाफाईड प्रमाणपत्र"}
          </h3>
          {!isStudentActive && (
            <div className="alert alert-warning">
              {language === "English"
                ? "This student is inactive. Please activate the student to print the Bonafide certificate."
                : "हा विद्यार्थी निष्क्रिय आहे. बोनाफाईड प्रमाणपत्र प्रिंट करण्यासाठी कृपया विद्यार्थ्याला सक्रिय करा."}
              <br /> <Link
                to={`/student-register/?serialNo=${formData.serialNo}`}
              >
                {language === "English" ? "Edit Student Information" : "विद्यार्थी माहिती संपादित करा"}
              </Link>
            </div>
          )}
          <div className="form-output">
            {/* <form onSubmit={handleSubmit}> */}
            <form>
              <div className="form-group l3">
                <label>{language === "English" ? "Register No " : "रजिस्टर क्र."}</label>
                <input
                  className="input-field"
                  type="text"
                  name="registerno"
                  value={formData.registerno}
                  onChange={handleChange}
                  required
                />
              </div>
              <br />
              <div className="form-group l3">
                <label>{language === "English" ? "Name " : "नाव"}</label>
                <input
                  className="input-field"
                  type="text"
                  name="stdName"
                  value={searchInput}
                  onChange={handleChange}
                  placeholder={language === "English" ? "Search by name..." : "नावाने शोधा..."}
                  required
                  readOnly={!isEditable && formData.registerno ? true : false}
                />
              </div>
              <br />

              <div className="form-group">
                <label style={{ fontSize: '16px' }}>
                  {language === "English" ? "Mother's Name" : "आईचे नाव"}
                </label>
                <input
                  className="input-field"
                  type="text"
                  name="stdMother"
                  value={formData.stdMother}
                  onChange={handleChange}
                  required
                  readOnly={!isEditable}
                />
              </div>
              <br />


              <div className="form-group">
                <label style={{ fontSize: '16px' }}>{language === "English" ? "Religion" : "धर्म"}</label>
                <input
                  className="input-field"
                  type="text"
                  name="religion"
                  value={formData.religion}
                  onChange={handleChange}
                  required
                  readOnly={!isEditable}
                />
              </div>


              <br />
              <div className="form-group">
                <label style={{ fontSize: '16px' }}>{language === "English" ? "Class" : "वर्ग"}</label>
                <input
                  className="input-field"
                  type="text"
                  name="class"
                  value={formData.class}
                  onChange={handleChange}
                  required
                />
              </div>
              <br />

              <div className="form-group">
                <label style={{ fontSize: '16px' }}>
                  {language === "English" ? "Academic Year" : "शैक्षणिक वर्ष"}
                </label>
                <input
                  className="input-field"
                  type="text"
                  name="educationalYear"
                  value={formData.educationalYear}
                  onChange={handleChange}
                  required
                />
              </div>
              <br />
              <div className="form-group">
                <label style={{ fontSize: '16px' }}>{language === "English" ? "DOB" : "जन्मतारीख"}</label>
                <input
                  className="input-field"
                  type="text"
                  name="dob"
                  value={formData.dob}
                  onChange={handleChange}
                  required
                  readOnly={!isEditable}
                />
              </div>
              <br />
              <div className="form-group l3">
                <label>O.W. No.</label>
                <input
                  style={{ marginRight: '42px' }}
                  placeholder='Temporary O.W.No change, no change to the database.'
                  className="input-field"
                  type="text"
                  name="owtId"
                  value={formData.owtId || ''}
                  onChange={handleChange}
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px', width: '100%', gap: '8px' }}>
                <input
                  type="checkbox"
                  name="showOwtId"
                  checked={formData.showOwtId === true}
                  onChange={(e) => setFormData(prev => ({ ...prev, showOwtId: e.target.checked }))}
                  style={{ margin: 0, width: '18px', height: '18px', cursor: 'pointer', flex: 'none' }}
                />
                <label style={{ fontSize: '14px', cursor: 'pointer', margin: 0, padding: 0, flex: 'none', width: 'auto', fontWeight: '500', color: '#555' }}>
                  Show O.W. No. on Certificate
                </label>
              </div>
              <br />


              <div className="form-group l1">
                <label>{language === "English" ? "Reason" : "कारण"}</label>
                <select className="input-field" name="reason"
                  value={isReasonOther ? "Other" : formData.reason} // Keep "Other" selected if the input is active
                  onChange={(e) => handleSelectChange(e, "reason")} required>

                  <option value={language === "English" ? "To avail of travel benefits" : "प्रवासाचे फायदे मिळावेत"}>
                    {language === "English" ? "To avail of travel benefits" : "प्रवासाचे फायदे मिळावेत"}
                  </option>
                  <option value={language === "English" ? "For educational loans from a school or bank" : "शाळा किंवा बँकेकडून शैक्षणिक कर्जासाठी"}>
                    {language === "English" ? "For educational loans from a school or bank" : "शाळा किंवा बँकेकडून शैक्षणिक कर्जासाठी"}
                  </option>
                  <option value={language === "English" ? "For permission to visit an industry for project work" : "प्रकल्पाच्या कामासाठी उद्योगाला भेट देण्याच्या परवानगीसाठी"}>
                    {language === "English" ? "For permission to visit an industry for project work" : "प्रकल्पाच्या कामासाठी उद्योगाला भेट देण्याच्या परवानगीसाठी"}
                  </option>
                  <option value={language === "English" ? "To open a bank account" : "बँक खाते उघडण्यासाठी"}>
                    {language === "English" ? "To open a bank account" : "बँक खाते उघडण्यासाठी"}
                  </option>
                  <option value={language === "English" ? "Other" : "इतर"}>{language === "English" ? "Other" : "इतर"}</option>
                </select>
                {isReasonOther && (
                  <div style={{ marginTop: '10px', marginLeft: '105px', width: '420px' }}>
                    <input
                      className="input-field"
                      name="reason"
                      value={formData.reason}
                      onChange={(e) => {
                        handleChange(e);
                        if (e.target.value === "") {
                          setIsReasonOther(false);
                        }
                      }}
                    />
                  </div>
                )}
              </div>

            </form>
          </div>

          {showDuplicatePopup && (
            <div className="popup-container">
              <DuplicateStudentPopup
                duplicateStudents={duplicateStudents}
                onSelectStudent={handleSelectStudent}
              />
            </div>
          )}
        </div>
        <div >
          <Bonadoc
            formData={formData} isStudentActive={isStudentActive}
          />
        </div>
      </div>
    </div>
  );
};

export default Bonafide;